import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { LayoutContext } from 'providers/LayoutProvider'
import { FdrPage } from 'utils/environmentConfig'

const ClientDashboardLoginContext = createContext(null)

export const ClientDashboardLoginProvider = ({ children }) => {
  const { state } = useContext(LayoutContext)
  const isFdr = state?.siteEnv === FdrPage

  const [isOpen, setIsOpen] = useState(false)
  const [openedFromShowFormCookie, setOpenedFromShowFormCookie] = useState(false)

  const openLoginOverlay = useCallback(() => {
    setOpenedFromShowFormCookie(false)
    setIsOpen(true)
  }, [])

  const closeLoginOverlay = useCallback(() => {
    setOpenedFromShowFormCookie(false)
    setIsOpen(false)
  }, [])

  const value = useMemo(
    () => ({
      isOpen,
      openLoginOverlay,
      closeLoginOverlay,
      openedFromShowFormCookie,
    }),
    [isOpen, openLoginOverlay, closeLoginOverlay, openedFromShowFormCookie]
  )

  if (!isFdr) {
    return children
  }

  return (
    <ClientDashboardLoginContext.Provider value={value}>
      {children}
    </ClientDashboardLoginContext.Provider>
  )
}

export const useClientDashboardLogin = () => {
  const ctx = useContext(ClientDashboardLoginContext)
  if (!ctx) {
    return {
      isOpen: false,
      openLoginOverlay: () => {},
      closeLoginOverlay: () => {},
      openedFromShowFormCookie: false,
    }
  }

  return ctx
}
